<template>
    <el-dialog :title="fileTransferTextConfig.title" v-if="fileDialogVisible" :visible.sync="fileDialogVisible" width="500px"
               @close="fileClose" :close-on-click-modal="false" :close-on-press-escape="false">
        <el-tabs class="fileTab" v-model="fileTab" type="card" :style="{'height':height+'px'}"
                 @tab-click="handleClickFileTab">
            <el-tab-pane :label="fileTransferTextConfig.export.title" name="0">
                <p><i style="color:#F56C6C">*</i> {{ fileTransferTextConfig.export.tip }}</p>
                <el-breadcrumb class="breadcrumb" separator="/" style="padding-top:5px;line-height: 20px">
                    <el-breadcrumb-item v-if="breadcrumbList.length > 0" class="breadcrumb-name" @click.native="goFolder(null, null)" :key="-1">
                        <span><a>/data</a></span>
                    </el-breadcrumb-item>
                    <el-breadcrumb-item v-else class="breadcrumb-name" :key="-1" >
                        <span>/data</span>
                    </el-breadcrumb-item>
                    <el-breadcrumb-item class="breadcrumb-name" v-for="(item, index) in breadcrumbList" @click.native="goFolder(item,index)" :key="item.index">
                        <span><a>{{ item.name }}</a></span>
                    </el-breadcrumb-item>
                </el-breadcrumb>
                <el-table ref="multipleTable" v-loading="tableLoading" id="fileList"
                          element-loading-text="加载中"
                          element-loading-spinner="el-icon-loading" :data="importFileList" :height="height-100"
                          size="mediue" tooltip-effect="dark" style="width: 100%"
                          @selection-change="handleSelectionChange">
                    <el-table-column type="selection" width="48" align="center"
                                     :selectable="checkSelectable"></el-table-column>
                    <el-table-column :label="'已选 '+multipleSelection.length+'/'+ getAllFileLength()"
                                     min-width="120" show-overflow-tooltip prop="name">
                        <template slot-scope="scope">
                            <a v-if="scope.row.dir" @click="showFiles(scope.row.name)"><i class="el-icon-folder" style="padding-right: 5px;"></i>{{scope.row.name}}</a>
                            <template v-else="scope.row.dir">{{scope.row.name}}</template>
                        </template>
                    </el-table-column>
                    <el-table-column label="" width="80" prop="src" align="center" :key="columnKey">
                        <template slot-scope="scope">
                                <span v-if="!scope.row.dir && scope.row.disable !== false" style="color:#0070de"><i
                                        class="el-icon-loading"></i> {{ scope.row.disable }} %</span>
                            <el-button v-if="!scope.row.dir" icon="el-icon-download" circle
                                       @click="scope.row.disable=0,downLoad([scope.row], 0)"></el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </el-tab-pane>
            <el-tab-pane class="h100p" :label="fileTransferTextConfig.import.title" name="1">
                <p><i style="color:#F56C6C">*</i> {{ fileTransferTextConfig.import.tip }}</p>
                <el-upload
                        :drag="height<370?false:true"
                        multiple action="void"
                        ref="file"
                        :file-list="fileList"
                        :on-change="onChange"
                        :on-remove="handleRemove"
                        :http-request="uploadFile"
                        :auto-upload="false"
                        style="height:100%;margin-top:10px">
                    <i class="el-icon-upload" v-if="height>370"></i>
                    <div class="el-upload__text" v-if="height>370" v-html="fileTransferTextConfig.import.uploadText"></div>
                    <el-button v-else type="primary" style="float:left;margin-bottom:10px">{{ fileTransferTextConfig.import.upload }}</el-button>
                </el-upload>
                <!-- <el-progress v-show="clickExport" type="line" :percentage="filePercentage"></el-progress> -->
            </el-tab-pane>
        </el-tabs>
        <span slot="footer" class="dialog-footer">
                <el-button @click="fileClose()">{{ fileTransferTextConfig.cancel }}</el-button>
                <el-button v-if="fileTab == 0" type="primary" :disabled="multipleSelection.length==0"
                           @click="exportFile()">{{ fileTransferTextConfig.export.name }}</el-button>
                <el-button v-else type="primary" @click="importFile()">{{ fileTransferTextConfig.import.name }}</el-button>
            </span>
    </el-dialog>
</template>

<script>
import axios from "axios";

export default {
    name: "fileTransfer",
    props: ['instancesId'],
    data() {
        return {
            fileDialogVisible: false,
            fileTab: 0,
            height: 400,
            tableLoading: false,
            removeSuccessList: [],
            fileList: [],
            importFileList: [],
            multipleSelection: [],
            columnKey: 0,
            breadcrumbList:[],
        }
    },
    computed: {
        fileTransferTextConfig() {
            return this.$store.state.global.textConfig.frontend.practicalTraining.button.fileTransfer
        },
    },
    methods: {
        open() {
            this.fileDialogVisible = true
            this.breadcrumbList = []
            this.showFiles(null)
            this.$store.dispatch("getTrainingUploadFileUrl", this.instancesId).then(res => {
                if (res.status == 200) {
                    this.uploadUrl = res.data.url
                    this.uploadHeaders = res.data.headers
                }
            })
            setTimeout(() => {
                if (this.height < 370) {
                    document.getElementsByClassName('el-upload-list')[0].style.height = this.height - 142 + 'px'
                } else {
                    document.getElementsByClassName('el-upload-list')[0].style.height = this.height - 268 + 'px'
                }
                window.onresize = () => {
                    if (this.fileDialogVisible) {
                        this.height = (document.body.clientHeight * 0.8 - 120) > 450 ? 450 : document.body.clientHeight * 0.8 - 120
                        if (this.height < 370) {
                            document.getElementsByClassName('el-upload-list')[0].style.height = this.height - 142 + 'px'
                        } else {
                            document.getElementsByClassName('el-upload-list')[0].style.height = this.height - 268 + 'px'
                        }
                    }
                };
            }, 200);
        },
        fileClose() {
            this.fileDialogVisible = false
            this.fileTab = 0
            this.multipleSelection = []
        },
        handleClickFileTab() {
            if (this.fileTab == 0) {
                this.fileDialogVisibleOpen()
            }
        },
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },
        checkSelectable(row) {
            return row.dir === false
        },
        async downLoad(arr, index) {
            let _this = this
            let data = {id: this.instancesId, name: arr[index].name}
            this.$store.dispatch("getTrainingFileDetail", data).then(res => {
                if (res.status === 200) {
                    _this.downLoadByUrl(res.data.url, res.data.headers, res.data.file_name)
                }
                if (index < arr.length - 1) {
                    index++
                    return _this.downLoad(arr, index)
                }
            })
            this.$refs.multipleTable.clearSelection()
        },
        downLoadByUrl(url, headers, name) {
            let obj = {};

            function setKeyAndValue(key, value) {
                obj[key] = value
            }

            for (let j = 0; j < headers.length; j++) {
                const e = headers[j].split(': ');
                setKeyAndValue(e[0], e[1])
            }
            let u = url.split('/')

            let index = 0
            for (let i = 0; i < this.importFileList.length; i++) {
                const e = this.importFileList[i].name;
                if (e === name) {
                    index = i
                }
            }
            let _this = this
            const xhr = new XMLHttpRequest();
            xhr.open('GET', _this.config_env.BASE_URL + '/' + u[u.length - 1], true);
            xhr.responseType = 'blob';
            for (let j = 0; j < headers.length; j++) {
                const e = headers[j].split(': ');
                setKeyAndValue(e[0], e[1])
                xhr.setRequestHeader(e[0], e[1]);
            }
            // 为了避免大文件影响用户体验，建议加loading
            xhr.onload = () => {
                if (!xhr.response.type.includes('application/octet-stream')) {
                    this.$message({
                        message: '下载云平台文件失败',
                        type: 'error'
                    });
                    _this.importFileList[index].disable = false;
                    return;
                }

                var blob = new Blob([xhr.response]);
                var FileSaver = require('file-saver');
                FileSaver.saveAs(blob, name);
                _this.importFileList[index].disable = false
            };
            // xhr.onerror =  uploadFail; //请求失败
            xhr.onprogress = function (evt) {
                _this.importFileList[index].disable = Math.round(evt.loaded / evt.total * 100)
                _this.columnKey += 1
                if (evt.lengthComputable) {//
                }
            } //上传进度调用方法实现
            xhr.send();
        },
        onChange(file, fileList) {
            if (file.status === 'ready') {
                const isLt2M = file.size / 1024 / 1024 < 100
                if (!isLt2M) {
                    fileList.pop();
                    this.$message({
                        message: '上传文件大小不能超过 100MB!',
                        type: 'warning'
                    });
                    return
                }
                // 存在文件标识
                let existsFileFlag = true;
                for (let i = 0; i < this.fileList.length; i++) {
                    if (file.name === this.fileList[i].name) {
                        existsFileFlag = false;
                    }
                }
                // 遍历的这个文件存在当前列表直接结束
                if (!existsFileFlag) {
                    // 否则不加入
                    fileList.pop();
                    // this.handleMsg(`文件已经选择过了：pom.xml)`);
                    this.$message({message: '文件列表中已存在文件：' + file.name, type: 'warning'});
                    return
                }
                if (isLt2M && existsFileFlag) {
                    this.fileList.push(file)
                }
            }
        },
        handleRemove(file, fileList, fileIndex) {
            if (file.status === 'success') {
                this.successNum--
                this.fileList = fileList
                this.removeSuccessList.push(file)
            } else if (file.status === 'ready') {
                this.fileList = fileList
                this.$message({message: '成功移除' + file.name, type: 'success'});
            } else if (file.status === 'uploading') {
                for (let i = 0; i < this.fileList.length; i++) {
                    const name = this.fileList[i].name;
                    if (file.name === name) {
                        // this.http[i]()
                        // this.http.splice(i, 1)
                    }
                }
                this.fileList = fileList
            }
        },
        exportFile() {
            let arr = [...this.multipleSelection]
            for (let i = 0; i < this.importFileList.length; i++) {
                const e = this.importFileList[i].name;
                for (let j = 0; j < arr.length; j++) {
                    const f = arr[j].name;
                    if (e === f) {
                        this.importFileList[i].disable = 0
                    }
                }
            }
            this.downLoad(arr, 0)
            this.columnKey += 1
        },
        importFile() {
            setTimeout(() => {
                this.$refs.file.submit();
            }, 200);
        },
        uploadFile(file) {
            let _this = this
            let f = file.file
            let formData = new FormData();
            formData.append("file", f);
            let CancelToken = axios.CancelToken
            // let u = _this.uploadUrl[_this.uploadUrl.length-1]
            axios.post(_this.uploadUrl, formData, {
                cancelToken: new CancelToken(function executor(c) {
                    if (_this.http) {
                        _this.http.push(c)
                    }
                    // 这个参数 c 就是CancelToken构造函数里面自带的取消请求的函数，这里把该函数当参数用
                }),
                //上传进度
                withCredentials: true,
                headers: _this.uploadHeaders,
                onUploadProgress: (progressEvent) => {
                    let num = progressEvent.loaded / progressEvent.total * 99 | 0;  //百分比
                    file.onProgress({percent: num})     //进度条
                }
            }).then(res => {
                if (res.data.code === 0) {
                    file.onProgress({percent: 100})
                    file.onSuccess(); //上传成功(打钩的小图标)
                    this.successNum += 1
                    this.successFun()
                } else {
                    // file.onProgress({percent: 100})
                    // file.onError();
                    this.$message({message: f.name + '上传失败', type: 'error', duration: 0, showClose: true});
                }
            }).catch(err => {
                // file.onProgress({percent: 100})
                // file.onError();
                this.$message({message: f.name + '上传失败', type: 'error', duration: 0, showClose: true});
            })
        },
        successFun() {
            if (this.successNum === this.fileList.length) {
                this.fileDialogVisible = false
                if (this.successNum > 0) {
                    this.$message({message: '上传成功', type: 'success'});
                }
                this.fileList = []
                this.http = []
                this.successNum = 0
            }
        },
        showFiles (name) {
            let dirPath = null
            if (name !=  null) {
                if (this.breadcrumbList.length > 0) {
                    dirPath = this.breadcrumbList[this.breadcrumbList.length - 1].fullDirName + "/" + name
                } else {
                    dirPath = name
                }
                this.breadcrumbList.push({index: this.breadcrumbList.length, name: name, fullDirName: dirPath})
            }
            this.tableLoading = true
            this.$store.dispatch("getTrainingFileList", {id:this.instancesId, dirPath: dirPath}).then(res => {
                if (res.status == 200) {
                    this.importFileList = res.data
                    for (let i = 0; i < this.importFileList.length; i++) {
                        this.importFileList[i].disable = false
                    }
                    this.$nextTick(() => {
                        this.$refs.multipleTable.doLayout()
                        this.removeDirCheckbox()
                    })
                }
                this.tableLoading = false
            }).catch(err => {
                this.tableLoading = false
            })
        },
        goFolder(item, index) {
            if (item == null) {
                this.breadcrumbList =[]
                this.showFiles (null)
            } else {
                if (index != this.breadcrumbList.length -1) {
                    this.breadcrumbList = this.breadcrumbList.slice(0,item.index)
                    this.showFiles (item.name)
                }
            }
        },
        removeDirCheckbox() {
            const elements = document.getElementById("fileList").querySelectorAll('.el-checkbox');
            elements.forEach(element => {
                if (element.classList.contains("is-disabled")) {
                    element.style="display:none"
                } else{
                    element.style="display:block"
                }

            });
        },
        getAllFileLength() {
            let list = this.importFileList.filter(item => item.dir == false)
            return list.length
        }
    }
}
</script>

<style scoped>
.fileTab >>> .el-tabs__header {
    margin-bottom: 10px;
}

.fileTab >>> .el-tabs__content {
    height: calc(100% - 56px);
}

.fileTab >>> .el-tabs__content .el-upload-list {
    overflow: auto;
}
.el-button--small.is-circle {
    padding: 5px;
}
.el-breadcrumb__item {
    float: none;
}
</style>